/**
 * Labstep
 *
 * @module grid/SmartTableProtocolCondition/components/TemplateLoader
 * @desc Load a template if any
 */

import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { GridSmartTableTemplateLoaderProps } from './types';

const GridSmartTableTemplateLoader: React.FC<
  GridSmartTableTemplateLoaderProps
> = ({ entityName, templateId, children, ...rest }) => {
  if (!templateId || !entityName) {
    return children({
      template: undefined,
      ...rest,
    });
  }
  return (
    <ReadOnMountHOC
      key={templateId}
      type="cursor"
      entityName={entityName}
      params={{
        id: templateId,
        is_template: 1,
      }}
      loading={false}
      children={({ entities }) => {
        const template =
          entities.length > 0 ? entities[0] : undefined;
        if (template && entityName !== template.entityName) {
          return null;
        }
        return children({
          template,
          ...rest,
        });
      }}
    />
  );
};

export default withRouter(GridSmartTableTemplateLoader);
